<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="formData" :model='formData' label-position="right" :label-width="200"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="上级菜单" prop="pname">
              <Input placeholder="请选择上级菜单" class="" v-model="formData.pname" disabled=""></Input>
            </FormItem>
          </Col>


          <Col span="24">
            <FormItem label="菜单名称" prop="menu_name">
              <Input placeholder="请输入菜单名称" class="" v-model="formData.menu_name"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="权限名称" prop="permission">
              <Input placeholder="请输入权限名称" class="" v-model="formData.permission"></Input>
            </FormItem>
          </Col>

        </Row>

        <FormItem>
          <Button type="primary" class="submission" @click="submitFormData">提交</Button>
        </FormItem>

      </Form>
<!--      <Tree :data="menuTree" @on-click="handleNodeClick" :render="renderContent"></Tree>-->
      <Tree :data="menuTree" @on-select-change="selectChange"></Tree>
    </Card>
  </div>
</template>

<script>
import { systemMenuSaveApi, systemMenuTreeApi } from '@/api/systemMenu'

export default {
  name: 'systemMenu',
  data () {
    return {
      menuTree: [],
      formData: {
        pid: 0,
        pname: '顶级菜单',
        menu_name: '',
        permission: '',
      },
    }
  },
  created () {
    this.loadTreeData()
  },
  methods: {
    // 加载数据
    loadTreeData() {
      systemMenuTreeApi().then(res => {
        if (res.code == 200) {
          this.menuTree = res.data

        } else {
          this.$Message.error(res.msg)
        }
      })
    },
    selectChange(data, item){
      this.formData.pid = item.id
      this.formData.pname = item.title
    },
    // 添加菜单
    submitFormData() {
      systemMenuSaveApi(this.formData).then(res => {
        if (res.code == 200) {
          this.$Message.success('添加成功')
          this.loadTreeData()
          this.formData.menu_name = ''
          this.formData.permission = ''
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
  }
}
</script>
